import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login/Login'
import Home from '@/components/home/Home'
import User from '@/pages/platform/sys/user/User'
import PasswordUpdate from '@/pages/platform/sys/user/PasswordUpdate'


import TaskAdd from '@/pages/platform/task/TaskAdd'
import AllTask from '@/pages/platform/task/AllTask'
import RecordTask from '@/pages/platform/task/RecordTask'
import BlackList from '@/pages/platform/blacklist/BlackList'
import MinPrinceList from '@/pages/platform/minprince/MinPrinceList'
import MatchPrinceList from '@/pages/platform/minprince/MatchPrinceList'
import ReportList from '@/pages/platform/report/ReportList'
import ReportDetailed from '@/pages/platform/report/ReportDetailed'
import TravelWebNum from '@/pages/platform/report/TravelWebNum'
import TravelPatrolWebNum from '@/pages/platform/report/TravelPatrolWebNum'
import TravelProvinceWebNum from '@/pages/platform/report/TravelProvinceWebNum'
import TravelWechatSubject from '@/pages/platform/report/TravelWechatSubject'
import TravelAgency from '@/pages/platform/report/TravelAgency'
import ShowWebNum from '@/pages/platform/report/ShowWebNum'
import ShowInfoNum from '@/pages/platform/report/ShowInfoNum'
import ShowInfoProvince from '@/pages/platform/report/ShowInfoProvince'
import ShowWechatSubject from '@/pages/platform/report/ShowWechatSubject'
import PublicComment from '@/pages/platform/report/PublicComment'
import NetworkNum from '@/pages/platform/report/NetworkNum'
import NetworkWebNum from '@/pages/platform/report/NetworkWebNum'
import OtherNum from '@/pages/platform/report/OtherNum'
import CreateReportList from '@/pages/platform/createReport/CreateReportList'

import SuspectedList from '@/pages/platform/suspected/SuspectedList'
import ConfirmList from '@/pages/platform/suspected/ConfirmList'
import SuspectedSearh from '@/pages/platform/suspected/SuspectedSearh'
import ConfirmSearh from '@/pages/platform/suspected/ConfirmSearh'
import taskNumSta from '@/pages/platform/statistics/taskNumSta'
import queryNumSta from '@/pages/platform/statistics/queryNumSta'
import caseNumSta from '@/pages/platform/statistics/caseNumSta'
//import reportList from '@/pages/platform/yearReport/reportList'
import UserList from '@/pages/platform/user/UserList'
import CompanyList from '@/pages/platform/company/CompanyList'
import urlList from '@/pages/platform/url/urlList'
import IPList from '@/pages/platform/security/IPList'
import mailList from '@/pages/platform/mail/mailList'

import Main from '@/components/home/Main'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/home',
      component: Home,
      children: [
        {

          path: 'main',
          component: Main,
          children: [
            {
              path: 'sys/user',
              component: User,
            },
            {
              path: 'sys/user/pwdUpdate',
              component: PasswordUpdate,
            },{
              path: 'task/TaskAdd',
              component: TaskAdd,
            },{
              path: 'task/AllTask',
              component: AllTask,
            },{
              path: 'task/RecordTask',
              component: RecordTask,
            },{
              path: 'suspected/SuspectedList',
              component: SuspectedList,
            },{
              path: 'suspected/ConfirmList',
              component: ConfirmList,
            },{
              path: 'suspected/SuspectedSearh',
              component: SuspectedSearh,
            },{
              path: 'suspected/ConfirmSearh',
              component: ConfirmSearh,
            },{
              path: 'statistics/taskNumSta',
              component: taskNumSta,
            },{
              path: 'statistics/queryNumSta',
              component: queryNumSta,
            },{
              path: 'statistics/caseNumSta',
              component: caseNumSta,
            },{
              path: 'report/ReportList',
              component: ReportList,
            },{
              path: 'report/ReportDetailed',
              component: ReportDetailed,
            },{
              path: 'report/TravelWebNum',
              component: TravelWebNum,
            },{
              path: 'report/TravelPatrolWebNum',
              component: TravelPatrolWebNum,
            },{
              path: 'report/TravelWechatSubject',
              component: TravelWechatSubject,
            },{
              path: 'report/TravelAgency',
              component: TravelAgency,
            },{
              path: 'report/TravelProvinceWebNum',
              component: TravelProvinceWebNum,
            },{
              path: 'report/ShowWebNum',
              component: ShowWebNum,
            },{
              path: 'report/ShowInfoNum',
              component: ShowInfoNum,
            },{
              path: 'report/ShowInfoProvince',
              component: ShowInfoProvince,
            },{
              path: 'report/ShowWechatSubject',
              component: ShowWechatSubject,
            },{
              path: 'report/ShowWechatSubject',
              component: ShowWechatSubject,
            },{
              path: 'report/PublicComment',
              component: PublicComment,
            },{
              path: 'report/NetworkNum',
              component: NetworkNum,
            },{
              path: 'report/NetworkWebNum',
              component: NetworkWebNum,
            },{
              path: 'report/OtherNum',
              component: OtherNum,
            } ,{
              path: 'createReport/CreateReportList',
              component: CreateReportList,
            } ,{
              path: 'user/UserList',
              component: UserList,
            },{
              path: 'company/CompanyList',
              component: CompanyList,
            },{
              path: 'url/urlList',
              component: urlList,
            },{
              path: 'security/IPList',
              component: IPList,
            },{
              path: 'mail/mailList',
              component: mailList,
            },{
              path: 'blacklist/BlackList',
              component: BlackList,
            },{
              path: 'minprince/MinPrinceList',
              component: MinPrinceList,
            },{
              path: 'minprince/MatchPrinceList',
              component: MatchPrinceList,
            }
          ]

        },

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js